var _circle, _path, _path2, _rect, _rect2, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlowWatermark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 362.7 362.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 181.36,
    cy: 181.36,
    r: 172.93,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.36,362.7C81.36,362.7,0,281.36,0,181.36S81.36,0,181.36,0,362.7,81.36,362.7,181.36,281.36,362.7,181.36,362.7Zm0-345.87c-90.71,0-164.53,73.82-164.53,164.53S90.65,345.87,181.36,345.87s164.51-73.8,164.51-164.51S272.07,16.83,181.36,16.83Z",
    fill: "#37abc8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.32,138.11h-.07A19.77,19.77,0,1,0,223.32,145h0v0c.05.24.08.47.13.7C240,229.9,200.19,234.89,155,240.54c-62.8,7.85-73.59,39.63-73.59,39.63s0,11.32,11.32,11.32H206s67.93,0,67.93-67.92C273.91,183.93,268,177.74,262.32,138.11Z",
    fill: "#795548"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 243.31,
    y: 104.68,
    width: 44.21,
    height: 11.32,
    transform: "translate(10.74 243.6) rotate(-50.2)",
    fill: "#795548"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 214.47,
    y: 88.82,
    width: 11.32,
    height: 48.7,
    transform: "translate(-24.78 149.03) rotate(-35.54)",
    fill: "#795548"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.91,
    cy: 99.02,
    r: 11.32,
    fill: "#5d4037"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 211.64,
    cy: 99.02,
    r: 11.32,
    fill: "#5d4037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.62,140.07c-1.71-4.14-5.87-7.1-11.36-7.1a11.33,11.33,0,0,0-11.32,11.33c0,1.82,14.07,73.75,0,101.89-17,34-39.62,34-50.95,34H81.44s0,11.32,11.32,11.32H206s73.59,5.66,73.59-62.27C279.57,190.28,268.25,183.92,262.62,140.07Z",
    fill: "#bcaaa4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.2,172.37c-.09-.12-.12-.25-.2-.38,3.66,59-32.07,63.56-72,68.55a148.54,148.54,0,0,0-35.42,8.54c-2.47,1.73-4.21,2.52-4.94,2h0c-2.08.93-4.06,1.88-5.92,2.85l-.12.07c-1.82,1-3.53,1.92-5.11,2.91h0a84.64,84.64,0,0,0,35.77,16.11c1.64.3,3.57.58,5.7.87.61.07,1.22.18,1.83.24a109.06,109.06,0,0,0,12.2.71,93,93,0,0,0,10.85-.62l2.41-.29,2.08-1.25a91.44,91.44,0,0,0,17.55-13.61,75.71,75.71,0,0,0,11.53-14.94c17-4,35.85-14.1,36.52-34.74C239.94,208.35,241.71,192.18,227.2,172.37Z",
    fill: "#4e342e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.44,189.7a73.59,73.59,0,0,1,147.18,0c0,.81,1.06,10.62-1.06,19.46C221.19,237.82,189,235,189,235s-17.7,28.3-34,28.3A73.58,73.58,0,0,1,81.44,189.7Z",
    fill: "#ff9800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.86,150.25c1.16-.08,2.32-.17,3.51-.17a45.5,45.5,0,0,1,8.63.84c3.19-7.6,7.14-20,6.47-34.14a75.44,75.44,0,0,0-9.44-.67c-.66,0-1.29.09-1.94.11C154.08,131.39,148.51,144.82,145.86,150.25Z",
    fill: "#ffb74d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.37,154.77a44.75,44.75,0,0,1,11.92-3.93c.92-9.47.62-21.36-3.83-32.54a73.79,73.79,0,0,0-10.74,3.54C131.45,133.17,130.76,146,129.37,154.77Z",
    fill: "#ffb74d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.38,158.32c4.58-7.2,11.24-19.6,13.61-33.86a73.13,73.13,0,0,0-10.76-4.56c-1.62,13.88-8.62,26.51-12.91,33.12A45.56,45.56,0,0,1,175.38,158.32Z",
    fill: "#ffb74d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M101,194.43l3.18,2.12c0-.4-.06-.79-.06-1.19A45.51,45.51,0,0,1,105.57,184a44.84,44.84,0,0,0-23.29-4.94,74.06,74.06,0,0,0-.84,10.6c0,.27,0,.53,0,.81C92.87,189.42,100.43,194.08,101,194.43Z",
    fill: "#ffb74d"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M105,170.22l3.13,4.69,1.23-.82a45.41,45.41,0,0,1,16.83-17.6c-1.45-8.26-6.28-18.28-14.25-26.44a73.29,73.29,0,0,0-8.62,7.4c7.94,7.89,12,18,12,24v3.94l-1-1.42a48.08,48.08,0,0,0-20.07-15.77A72.76,72.76,0,0,0,88.64,158,36.27,36.27,0,0,1,105,170.22Z",
    fill: "#ffb74d"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M104.41,200.61l-2.12.71a46.6,46.6,0,0,0-17.16,11.31,72.63,72.63,0,0,0,5,11.78A35.38,35.38,0,0,1,105.89,212l1.26-.41A45.05,45.05,0,0,1,104.41,200.61Z",
    fill: "#ffb74d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M192.77,184.36l3.75,10.69c8.24-2.88,21.72-11.9,28.41-28.26a73.08,73.08,0,0,0-7.54-16A40,40,0,0,1,192.77,184.36Z",
    fill: "#ffb74d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.86,172.12c.85-.42,17.32-8.93,23.47-32a72.77,72.77,0,0,0-9.73-8.92c-3.37,22.34-18,30.32-18.83,30.76l-5,2.52Z",
    fill: "#ffb74d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M195.58,223.59c8.57-1.43,22.65-7.11,32.81-19.19a78.34,78.34,0,0,0,.23-14.7,74.62,74.62,0,0,0-.63-9.14c-6.36,26.63-33.08,31.65-34.28,31.86L190,224.52Z",
    fill: "#ffb74d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183.85,159.87a52.74,52.74,0,0,0-74.61,0,43.4,43.4,0,0,0,0,61.29,35.84,35.84,0,0,0,50.63,0,29.77,29.77,0,0,0,0-42.1,24.93,24.93,0,0,0-35.29,0,21.11,21.11,0,0,0,0,29.83,18,18,0,0,0,25.47,0,5.66,5.66,0,0,0-8-8,6.71,6.71,0,0,1-9.47,0,9.78,9.78,0,0,1,0-13.82,14,14,0,0,1,19.28,0,18.43,18.43,0,0,1,0,26.09,24.5,24.5,0,0,1-34.62,0,32.06,32.06,0,0,1,0-45.28,41.44,41.44,0,0,1,58.61,0,53.26,53.26,0,0,1,0,75.25,67.47,67.47,0,0,1-35.35,18.69,94.79,94.79,0,0,0,28,1.23,79.73,79.73,0,0,0,15.38-11.91A64.62,64.62,0,0,0,183.85,159.87Z",
    fill: "#ce630b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlowWatermark);
export default __webpack_public_path__ + "static/media/slow-watermark.a353233c31232c5b2f380c2bb7cf53b0.svg";
export { ForwardRef as ReactComponent };